/**
 * Local copy of LODSetting from @technology/web3d-plugin-trimbim.
 * The package does not export this enum correctly in some bundler contexts (e.g. Vite).
 * Values must match TrimbimSettings.lodSetting in web3d-plugin-trimbim.
 */
/* eslint-disable no-magic-numbers */
export enum LODSetting {
  High = 0.5,
  Optimal = 1,
  Low = 2,
}
/* eslint-enable no-magic-numbers */
